import { render, staticRenderFns } from "./remittance-reports-table.vue?vue&type=template&id=673f9c61&"
import script from "./remittance-reports-table.vue?vue&type=script&lang=js&"
export * from "./remittance-reports-table.vue?vue&type=script&lang=js&"
import style0 from "./remittance-reports-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports